/**
 * Filter Validation Schemas
 *
 * Zod schemas for validating filter values. These can be used
 * in both Server and Client Components for runtime validation.
 */

import { z } from "zod";
import {
  AGE_GROUP_FILTER,
  DATE_FILTER,
  MEMBERSHIP_FILTER,
  CLUB_TYPE_FILTER,
  SKILL_LEVEL_FILTER,
  PRICE_FILTER,
  MEMBERSHIP_FEE_FILTER,
  RADIUS_FILTER,
  EVENT_SORT,
  CLUB_SORT,
} from "./filterConstants";

// ==========================================
// Zod Validation Schemas
// ==========================================

export const ageGroupSchema = z.enum(
  Object.values(AGE_GROUP_FILTER) as [AGE_GROUP_FILTER, ...AGE_GROUP_FILTER[]],
);

export const dateSchema = z.enum(
  Object.values(DATE_FILTER) as [DATE_FILTER, ...DATE_FILTER[]],
);

export const membershipSchema = z.enum(
  Object.values(MEMBERSHIP_FILTER) as [
    MEMBERSHIP_FILTER,
    ...MEMBERSHIP_FILTER[],
  ],
);

export const clubTypeSchema = z.enum(
  Object.values(CLUB_TYPE_FILTER) as [CLUB_TYPE_FILTER, ...CLUB_TYPE_FILTER[]],
);

export const skillLevelSchema = z.enum(
  Object.values(SKILL_LEVEL_FILTER) as [
    SKILL_LEVEL_FILTER,
    ...SKILL_LEVEL_FILTER[],
  ],
);

export const priceSchema = z.enum(
  Object.values(PRICE_FILTER) as [PRICE_FILTER, ...PRICE_FILTER[]],
);

export const membershipFeeSchema = z.enum(
  Object.values(MEMBERSHIP_FEE_FILTER) as [
    MEMBERSHIP_FEE_FILTER,
    ...MEMBERSHIP_FEE_FILTER[],
  ],
);

export const eventSortSchema = z.enum(
  Object.values(EVENT_SORT) as [EVENT_SORT, ...EVENT_SORT[]],
);

export const clubSortSchema = z.enum(
  Object.values(CLUB_SORT) as [CLUB_SORT, ...CLUB_SORT[]],
);

export const radiusSchema = z.enum(
  Object.values(RADIUS_FILTER) as [RADIUS_FILTER, ...RADIUS_FILTER[]],
);
